exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-2af2b109],h2[data-v-2af2b109]{font-weight:400}ul[data-v-2af2b109]{list-style-type:none;padding:0}li[data-v-2af2b109]{display:inline;margin:0 10px}a[data-v-2af2b109]{color:#42b983}.image-list[data-v-2af2b109]{margin-top:12px;height:140px;display:inline-block}.rg-unsplash-photo[data-v-2af2b109]{float:left;margin-right:10px;margin-bottom:10px;width:200px;height:220px;text-align:center;background:#e9e8e8;padding:10px;font-size:11px}", ""]);

// exports
